export namespace MathHelper {
    /**
     * Linearly interpolates between a and b by t.
     * @param a The start value.
     * @param b The end value.
     * @param t The interpolation value between the two floats.
     */
    export function lerp(a: number, b: number, t: number): number {
        return a + (b - a) * t;
    }

    /**
     * Clamps value between min and max and returns value.
     * @param value The value.
     * @param min The min value.
     * @param max The max value.
     */
    export function clamp(value: number, min: number, max: number): number {
        return Math.min(Math.max(value, min), max);
    }

    /**
     * Loops the value t, so that it is never larger than length and never smaller than 0.
     * @param value The value.
     * @param length The length.
     */
    export function repeat(value: number, length: number): number {
        return ((value % length) + length) % length;
    }

    export function pingPong(x: number, l: number): number {
        let L = 2 * l;
        let T = x % L;

        if (T < l && T >= 0) {
            return T;
        } else {
            return L - T;
        }
    }
}
